/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import { ICancelarVendaCreditosResponse } from "@/hooks/vendas-creditos/cancelar-venda/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleCancelarVendaCreditos } from "@/domain/use-cases/vendas-creditos";

const notifySuccess = (message: string) =>
  toast(message, { type: "success", position: "top-center" });

const notifyError = (message: string) => toast(message, { type: "error", position: "top-center" });

export function useCancelarVendaCreditos() {
  const queryClient = useQueryClient(); // ← necessário para invalidar a query
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ICancelarVendaCreditosResponse, Error, number>({
    mutationFn: async (venda_credito_id) => {
      return await handleCancelarVendaCreditos(token!, venda_credito_id);
    },
    onSuccess: async () => {
      notifySuccess("Compra de créditos cancelada com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["vendas-creditos"] });
    },
    onError: () => {
      notifyError("Houve um problema ao cancelar a venda de crédito!");
    },
  });

  return {
    cancelarVenda: mutation.mutate,
    cancelarVendaAsync: mutation.mutateAsync,
    isLoadingCancelarVenda: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
